import { render, staticRenderFns } from "./NoticeWriter.vue?vue&type=template&id=dd72b330&scoped=true"
import script from "./NoticeWriter.vue?vue&type=script&lang=js"
export * from "./NoticeWriter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd72b330",
  null
  
)

export default component.exports